import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/components/toast-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent],
  template: `
  <div class="min-h-screen text-slate-800">
    <router-outlet></router-outlet>
    <app-toast-container />
  </div>`
})
export class AppComponent {}
